export default __webpack_public_path__ + "static/media/tiger_2.aa204b0f.mp3";